/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateKnotSessionRequest} from '@cash-web/protos/squareup/cash/postcard/app/KnotApi.pb'
import {CreateKnotSessionResponse} from '@cash-web/protos/squareup/cash/postcard/app/KnotApi.pb'


export const createKnotSession = (request: CreateKnotSessionRequest, options?: CashRequestOptions) => post<CreateKnotSessionRequest, CreateKnotSessionResponse>("/2.0/cash/create-knot-session", request, {...options, rejectOnError: true })